import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AccessTab from './accessTab';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function PagesTabPanel({ edit, accessArray, setAccessArray, tabPanel, adminAccess }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePermissionChange = (id, type, bool) => {
    const newObj = { ...accessArray };
    newObj[id][type] = bool;
    setAccessArray(newObj);
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">

          {
            Object.keys(tabPanel).map((id, index) => {
              return <Tab label={tabPanel[id].title} {...a11yProps(index)} key={id} />
            })
          }
        </Tabs>
      </Box>

      {
        Object.keys(tabPanel).map((id, index) => {
          return <CustomTabPanel value={value} index={index} key={id}>
            <AccessTab accessArray={accessArray} tab={tabPanel[id]} handlePermissionChange={handlePermissionChange} adminAccess={adminAccess} edit={edit} />
          </CustomTabPanel>
        })
      }

    </Box>
  );
}

export default PagesTabPanel
